import { Units } from "components/Condominiums/Units";

export const ListUnits = () => {
  return (
    <Units />
  );
};
